import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { MaskLines, HeroScrollFade } from './motion';
import HeroBackdrop from './HeroBackdrop';
import { scrollToId } from '../lib/scroll';

export const Hero = () => {
  const jump = (e, id) => {
    e.preventDefault();
    scrollToId(id);
  };

  return (
    <section id="home" className="hm-hero pg-grain">
      <HeroBackdrop />

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <HeroScrollFade>
          <div className="hm-hero-inner">
            <MaskLines
              className="hm-h1"
              delay={0.1}
              lines={[
                'Construim software',
                <>pentru <span className="accent">profesioniștii</span></>,
                <span className="accent">din drept.</span>,
              ]}
            />

            <motion.p
              className="hm-lead"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6, ease: [0.16, 1, 0.3, 1] }}
            >
              Trei aplicații care scot munca repetitivă din practica juridică: cercetarea în
              legislație, urmărirea dosarelor și corespondența de insolvență. Construite în
              România, împreună cu oamenii care le folosesc zilnic.
            </motion.p>

            <motion.div
              className="hm-hero-cta"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.72, ease: [0.16, 1, 0.3, 1] }}
            >
              <motion.a
                href="#produse"
                onClick={(e) => jump(e, '#produse')}
                className="pg-pill"
                whileHover={{ scale: 1.045 }}
                whileTap={{ scale: 0.97 }}
                transition={{ type: 'spring', stiffness: 300, damping: 18 }}
              >
                Vezi produsele <ArrowRight size={17} />
              </motion.a>
              <a href="#companie" onClick={(e) => jump(e, '#companie')} className="pg-ghost">
                Despre companie
              </a>
            </motion.div>
          </div>
        </HeroScrollFade>
      </div>
    </section>
  );
};

export default Hero;
